import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { __ } from "@service/api-client/http/helpers/translates";
import { LazyImage } from "../../../../elements/lazy-image-component.js";
import '../../../../assets/index.css';const loader = "styles-module_loader__bmoVj2rw__platform-common";
const loaderWrapper = "styles-module_loaderWrapper__ovxuSrLb__platform-common";
const loaderTitle = "styles-module_loaderTitle__cLDrblrm__platform-common";
const loaderSubtitle = "styles-module_loaderSubtitle__6E1GR6EK__platform-common";
const loaderLogo = "styles-module_loaderLogo__zZfgSbGF__platform-common";
const loaderText = "styles-module_loaderText__BJpw6iCh__platform-common";
const styles = {
  loader,
  loaderWrapper,
  loaderTitle,
  loaderSubtitle,
  loaderLogo,
  loaderText
};
var MainLoaderBrands = /* @__PURE__ */ ((MainLoaderBrands2) => {
  MainLoaderBrands2["Platform"] = "platform";
  MainLoaderBrands2["NationalCasino"] = "nationalCasino";
  MainLoaderBrands2["TonyBet"] = "tonyBet";
  MainLoaderBrands2["Bet22"] = "bet22";
  MainLoaderBrands2["BizzoCasino"] = "bizzoCasino";
  MainLoaderBrands2["Ivibet"] = "ivibet";
  return MainLoaderBrands2;
})(MainLoaderBrands || {});
const MainLoader = ({
  url,
  alt,
  hideRegistrationText = false
}) => /* @__PURE__ */ jsx("div", { className: styles.loader, children: /* @__PURE__ */ jsxs("div", { className: styles.loaderWrapper, children: [
  !hideRegistrationText && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: styles.loaderTitle, children: __("Registration_._Phrase_._Registration") }),
    /* @__PURE__ */ jsx("div", { className: styles.loaderSubtitle, children: __("Registration_._Phrase_._is almost done") })
  ] }),
  /* @__PURE__ */ jsx("div", { className: styles.loaderLogo, children: /* @__PURE__ */ jsx(LazyImage, { src: url, alt }) }),
  !hideRegistrationText && /* @__PURE__ */ jsx("div", { className: styles.loaderText, children: __("Registration_._Phrase_._please wait...") })
] }) });
export {
  MainLoader,
  MainLoaderBrands
};
